var exports = {
  "kL": "x127c5a35--4bd84a--container",
  "JE": "x127c5a35--4bd84a--under-construction",
  "Kk": "x127c5a35--4bd84a--icon",
};

module.exports = exports;
